module.exports = __webpack_public_path__ + "static/media/lightningGamesPlayed_10000_50000.875a5886.png";